import React from 'react';

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="section-title">
        <h2>Contact Us</h2>
      </div>
      <div className="contact-container">
        <div className="contact-info">
          <div className="contact-item">
            <div className="contact-item-icon">📧</div>
            <div>
              <h4>Email</h4>
              <p><a href="mailto:Jaatcollege@yahoo.com">Jaatcollege@yahoo.com</a></p>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-item-icon">📞</div>
            <div>
              <h4>Phone</h4>
              <p><a href="tel:+917082906310">+91 70829 06310</a></p>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-item-icon">🌐</div>
            <div>
              <h4>Website</h4>
              <p><a href="https://www.jcekarnal.in/" target="_blank" rel="noopener noreferrer">www.jcekarnal.in</a></p>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-item-icon">📍</div>
            <div>
              <h4>Location</h4>
              <p>Karnal, Haryana, India</p>
            </div>
          </div>
        </div>
        <div className="contact-map">
          <iframe
            title="Jaat College of Education Location"
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3465.8185760337287!2d77.06792827554047!3d29.696039175100932!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjnCsDQxJzQ1LjciTiA3N8KwMDQnMTMuOCJF!5e0!3m2!1sen!2sin!4v1787212782154!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default Contact;
